/* AIRE — fiche produit « etagere-3d-sur-mesure » (2026-10-22) : configurateur d'étagère relié au formulaire du thème.
   Monté par snippets/etagere-fiche.liquid. Facturation comme le pegboard sur mesure : une seule variante « unité »
   à 0,10 € (prix de base), quantité = prix de l'étagère / 0,10 € (ETAG.unitQty). Le montant affiché est celui
   facturé : quantité × prix de l'unité dans la devise du client. Au panier, snippets/lc-cart-lock.liquid masque
   la quantité et le prix unitaire et affiche _cart_title.
   Propriétés : Étagère / Clé étagère / _cle_etagere / _cart_title / _cfg_price_cents / _cfg_currency /
   _cfg_uid (renouvelé à chaque ajout : deux étagères identiques restent deux lignes). */
(function () {
  'use strict';
  var LBL = {
    fr: { missing: 'Ce produit ne peut pas être commandé en ligne pour le moment : contactez-nous.' },
    en: { missing: 'This product cannot be ordered online at the moment: please contact us.' },
    de: { missing: 'Dieses Produkt kann derzeit nicht online bestellt werden: Bitte kontaktieren Sie uns.' },
    es: { missing: 'Este producto no se puede pedir en línea por ahora: contáctanos.' },
    it: { missing: 'Questo prodotto non è ordinabile online al momento: contattaci.' },
    nl: { missing: 'Dit product kan momenteel niet online worden besteld: neem contact met ons op.' }
  };

  function init() {
    var E = window.ETAG, C = window.ETAGERE_FICHE, root = document.querySelector('[data-etagere-fiche]');
    if (!E || !E.mount || !C || !root || root._ef) return;
    root._ef = true;
    var LANG = E.normLang(C.lang), L = E.label(LANG), T = LBL[LANG] || LBL.en;
    var scope = root.closest('.shopify-section') || document;
    var form = scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var app = root.querySelector('[data-ef-app]'), priceEl = root.querySelector('[data-ef-price]'), noteEl = root.querySelector('[data-ef-note]');
    var unit = parseInt(C.unitCents, 10) || 0;
    var fmt = null;
    try { fmt = new Intl.NumberFormat(C.locale || LANG, { style: 'currency', currency: C.currency || 'EUR' }); } catch (e) { /* noop */ }
    function money(cents) { return fmt ? fmt.format(cents / 100) : E.euros(cents, LANG); }

    function hidden(name) {
      if (!form) return null;
      var el = form.querySelector('input[type="hidden"][name="' + name + '"][data-ef]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; el.setAttribute('data-ef', ''); form.appendChild(el); }
      return el;
    }
    function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

    function sync(st) {
      var qty = E.unitQty(st), charged = qty * unit, key = E.encode(st), sum = E.summary(st, LANG);
      if (priceEl) priceEl.textContent = unit ? money(charged) : E.euros(E.priceCents(st), LANG);
      if (form) {
        Array.prototype.forEach.call(form.querySelectorAll('[name="id"]'), function (el) { el.value = String(C.variantId); });
        var q = form.querySelectorAll('[name="quantity"]');
        if (q.length) Array.prototype.forEach.call(q, function (el) { el.value = String(qty); });
        else hidden('quantity').value = String(qty);
        hidden('properties[' + L.prop[0] + ']').value = sum;
        hidden('properties[' + L.prop[1] + ']').value = key;
        hidden('properties[_cle_etagere]').value = key;
        hidden('properties[_cart_title]').value = C.title + ' · ' + sum;
        hidden('properties[_cfg_price_cents]').value = String(charged);
        hidden('properties[_cfg_currency]').value = String(C.currency || 'EUR').toUpperCase();
      }
      var ok = !!unit && C.available !== false;
      if (form) Array.prototype.forEach.call(form.querySelectorAll('button[type="submit"], [name="add"]'), function (b) { b.disabled = !ok; b.toggleAttribute('data-ef-blocked', !ok); });
      if (noteEl) noteEl.textContent = ok ? '' : T.missing;
      return qty;
    }

    /* état de départ : ?etagere=<clé>, sinon 25 × 15 cm sans rebord, blanc */
    var start = null;
    try { var k = new URLSearchParams(location.search).get('etagere'); if (k) start = E.decode(k); } catch (e) { /* noop */ }
    var gen = E.mount(app, { lang: LANG, state: start || { w: 250, d: 150, rim: false, color: 'blanc' }, priceFor: function () { return ''; }, onChange: sync });
    sync(gen.getState());
    if (form) {
      hidden('properties[_cfg_uid]').value = uid();
      /* le thème peut ajouter au panier sans événement submit : identifiant renouvelé aussi au clic */
      form.addEventListener('click', function (e) { if (e.target.closest('button[type="submit"], [name="add"]')) { sync(gen.getState()); hidden('properties[_cfg_uid]').value = uid(); } }, true);
    }

    /* garde-fou : quantité (= prix), clé et identifiant de ligne à jour au moment de l'envoi */
    document.addEventListener('submit', function (e) {
      if (!form || e.target !== form) return;
      var qty = sync(gen.getState());
      hidden('properties[_cfg_uid]').value = uid();
      if (!unit || qty < 1) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    window.ETAGERE_FICHE.gen = gen;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
